import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../common/withRouter';
import {
  ButtonOBSOLETED,
  Notification,
  Message
} from '../../web.common';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';
import { FilterInput, Filters, FilterSelect, FilterSelectAsync } from './Filters';
import CrawlingResult from './Crawling/CrawlingResult';

class CrawlingAddInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      facilityProducts: null,
      crawlings: null
    };
  }

  componentDidMount() {
  }

  crawl(filters) {
    const { props: { api: { crawlings: { crawlProduct } } } } = this;

    this.setState({ isLoading: true }, async () => {
      let result = [];

      try {
        result = await crawlProduct({ filters });
      }
      catch (e) {
        console.error(`unable to load. ${e}`);
        this.setState({ isLoading: false, errorMessage: new Message('error', 'Unable to load data') });

        return;
      }

      document.location = `/crawling/${result}`;

      return result;
    });
  }

  async loadProducts(facilityId) {
    const { props: { api: { integrations: { searchIntegrations } } } } = this;

    let result = null;
    const filters = { facilityId, type: 1 };

    try {
      result = await searchIntegrations({ filters });
    }
    catch (e) {
      console.error(`unable to load. ${e}`);
      this.setState({ isLoading: false, errorMessage: new Message('error', 'Unable to load data') });

      return;
    }
    this.setState({ facilityProducts: result });
  }

  render() {
    const { isLoading, facilityProducts, crawlings, errorMessage } = this.state;
    const { api: { facilities: { lookupByNameOrId: lookupFacility } } } = this.props;

    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            <Notification newMessage={errorMessage} />
            <PageTop
              documentTitle='Crawl a product'
              documentDescription='Crawl a product'
            />

            <h2 className='main-page-header'>
              Crawl Product
            </h2>

            <Filters
              initFromUrl
              submitUrl
              onSubmit={values => 
                { 
                  if (!values || !values.productId) {
                    alert('Choose a product to crawl');

                    return;
                  }
                  return this.crawl(values);
                } 
                }
              validateForm={({
                facilityId,
                firstDay,
                daysToCrawl,
                productId
              }) => ({
                facilityId,
                firstDay,
                daysToCrawl,
                productId
              })}
              render={(formData, update) => (
                <div className='filters-block'>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='firstDay'>
                      First Day
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='firstDay'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='daysToCrawl'>
                      Days To Crawl
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='daysToCrawl'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='facilityId'>
                      Facility
                    </label>
                    <FilterSelectAsync
                      className='filter-select'
                      data={formData}
                      debounce
                      update={async (facility, value) => {
                        update(facility, value);
                        await this.loadProducts(value);
                      }}
                      name='facilityId'
                      loadOptions={async inputValue => lookupFacility(inputValue)}
                    />
                  </div>
                  {
                    facilityProducts
                      ? (
                        <div className='filters-label-block'>
                          <label className='filters-label' htmlFor='productId'>
                            Product
                          </label>
                          <FilterSelect
                            className='filter-select'
                            data={formData}
                            update={update}
                            name='productId'
                            options={facilityProducts.map(({ ProductId, ProductName }) =>
                              ({ value: ProductId, label: ProductName }))}
                          />
                        </div>
                      ) : null
                  }
                  <br />
                  <br />
                  <div className='filters-submit-wrapper'>
                    <ButtonOBSOLETED type='submit' buttonContent='Crawl' disabled={isLoading} />
                  </div>
                  <hr />
                </div>
              )}
            />

            {
              crawlings
                ? (
                  // TODO: This is a workaround to re-render the component.
                  <div key={`crawling-result-${new Date()}`}>
                    <CrawlingResult
                      data={crawlings}
                    />
                  </div>
                ) : null
            }
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}

const CrawlingAdd = withRouter(withApi(
  connect(({ user }) => ({ isLoggedIn: !!user }), {})(CrawlingAddInternal)
));

CrawlingAdd.requiresLogin = true;
CrawlingAdd.propTypes = { isLoggedIn: PropTypes.bool };

export default CrawlingAdd;